import { ICostCenter } from "@/core/interfaces/costCenter.interface";
import { ICostCenterState } from "../types";

const state: ICostCenterState = {
  costCenters: [] as ICostCenter[],
  isFetchingCostCenters: false,
  costCenterActionLoading: false,
};

export default state;
